<template>
	<div>
		<div class="prism-player" id="J_prismPlayer"></div>
		<div style="width: 90%;margin: 0 auto;">
			<div class="title">{{liveName}}</div>
			<div class="flex">
				<div class="flex" style="width: 95px;color: #666;">
					<div class="icon-yanjing iconfont"></div>
					<span style="color: #666;font-size: 14px;">{{count}}人观看</span>
				</div>
				<div class="flex" style="width: 50px;color: #666;">
					<div class="iconfont icon-fenxiang"></div>
					<span style="color: #666;font-size: 14px;" @click="openShare">分享</span>
				</div>
			</div>
		</div>

		<el-dialog title="分享" :visible.sync="qrimgVisible" :width="$commen.isphone()?'250px':'600px'">
			<el-row type="flex">
				<el-col :span="8">
					<vue-qr :logoSrc="imageUrl" :text="shareUrl" :size="200"></vue-qr>
				</el-col>
				<el-col :span="16" v-if="!$commen.isphone()">
					<p class="shareTextClass">分享到微信好友或朋友圈</p>
					<p class="shareTextClass">使用微信扫一扫</p>
				</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
			</span>
		</el-dialog>
		<div id="shareit" v-show="phoneSharebg" @click="closewxShare">
			<img src="../../../assets/guide_point.png" alt="Responsive image" id="share_btn">
		</div>


		<div class="line" style="margin: 10px 0;"></div>
		<!-- 切换栏 -->
		<div>
			<el-tabs v-model="activeName" :stretch="true">
				<el-tab-pane label="详情" name="1">
					<div v-html="infoObj.liveInfo"></div>
				</el-tab-pane>
				<el-tab-pane label="评论" name="2">
					<div style="background-color: #f5f5f5;padding: 15px;">
						<div class="chat-content" style="padding-left: 20px;overflow:auto;height: 220px;" v-model="sendmsg">
							<!-- recordContent 聊天记录数组-->
							<div v-for="(itemc,indexc) in msgList" :key="indexc">
								<!-- 对方 -->
								<div class="word">
									<img src="http://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/newMetting/DefaultAvatar.jpg" v-if="itemc.headImgurl == null || itemc.headImgurl == ''">
									<img :src=itemc.headImgurl v-else>
									<div class="info">
										<p class="time">{{itemc.ext.name}}</p>
										<div class="info-content">{{itemc.data}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style="display: flex;width: 100%;">
						<el-input placeholder="发个评论" v-model="sendmsg" class="input-with-select">
						</el-input>
						<el-button slot="append" type="primary" @click="sendMessage('jhjh')">发送</el-button>
					</div>
				</el-tab-pane>
				<el-tab-pane label="专家介绍" name="3">
					<div v-html="infoObj.expertInfo"></div>
				</el-tab-pane>
			</el-tabs>
			<el-dialog title="登录后可观看直播" :visible.sync="dialogVisible" width="95%" :before-close="handleClose">
				<singndialog @loginOk="loginOk"></singndialog>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import VueQr from 'vue-qr'
	import singndialog from '@/components/sigindialog/sigindialog.vue';
	export default {
		components: {
			singndialog,
			VueQr
		},
		data() {
			return {
				phoneSharebg: false,
				shareUrl: window.location.origin + window.location.pathname + "#/seleteLive",
				imageUrl: '',
				qrimgVisible: false,
				dialogVisible: true,
				activeName: '2',
				sendmsg: '',
				user: {},
				infoObj: {},
				msgList: [],
				count: 0,
				myindex: 1,
				id: '',
				liveName: 'live'
			}
		},
		methods: {
			closewxShare() {
				this.phoneSharebg = !this.phoneSharebg
			},
			openShare() {
				if (this.$commen.isWeiXin()) {
					this.phoneSharebg = true
				} else {
					this.qrimgVisible = true
				}
			},
			loginOk(e) {
				if (localStorage.getItem("user") && e) {
					this.dialogVisible = false
					this.init()
				}
			},
			handleClose() {
				if (localStorage.getItem("user")) {
					this.dialogVisible = false
				} else {
					this.$message.warning('此页面需要登录')
				}
			},
			joinLive() {
				let cnt = {
					id: this.id,
					userId: this.user.user.userId
				}
				this.$api.joinLive(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {} else {
						this.$message.error(res.data.rm);
					}
				});
			},
			isphone() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				if (flag) {
					return true
				} else {
					return false
				}
			},
			getUrl() {
				let cnt = {
					id: this.id,
				}
				this.$api.getLiveUrl(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						let obj = JSON.parse(res.data.c)
						this.infoObj = obj
						this.count = obj.count
						this.liveName = obj.liveName
						if (obj.type == '小鹅通') {
							window.location.href = obj.otherurl
						} else {
							let newUrl = JSON.parse(obj.pullUrl). [obj.type].m3u8
							var player = new Aliplayer({
								id: "J_prismPlayer", // 容器id
								source: newUrl, //视频地址
								cover: "http://ganzhiyu.oss-cn-hangzhou.aliyuncs.com/newMetting/1.jpg", //播放器封面图
								autoplay: true, // 是否自动播放
								width: "100%", // 播放器宽度
								height: this.isphone() ? "220px" : "540px", // 播放器高度
								playsinline: true,
								isLive: true
							})
							player.on('liveStreamStop', function() {
								console.log('直播已结束');
							});
							player.on('onM3u8Retry', function() {
								console.log('主播暂时离开，请稍后......');
							});
						}
					} else {
						this.$message.error(res.data.rm);
					}
				});
			},
			// 登录账号
			loginWebIM() {
				this.$imconn.open(this.$imoption);
				let _this = this;
				// 监听回调
				this.$imconn.listen({
					onOpened: function(message) {
						console.log("用户已上线");
					},
					onClosed: function(message) {
						console.log("用户下线");
						_this.$emit("isclose", true);
					},
					// 收到文本消息
					onTextMessage: function(message) {
						_this.msgList.push(message)
						console.log(_this.msgList)
					}
				});
			},
			//发送文本消息
			sendMessage(message) {
				console.log(this.sendmsg)
				let val = this.sendmsg.replace(/[\r\n]/g, "").replace(/[ ]/g, "");
				if (val != "") {
					console.log(val)
					var id = this.$imconn.getUniqueId();
					// 生成本地消息id
					var msg = new WebIM.message("txt", id);
					let _this = this;
					let option = {
						msg: val, // 消息内容
						to: '131613314842625', // 接收消息对象(群组id)
						chatType: 'groupChat', // 群聊类型设置为群聊
						ext: {
							name: _this.user.user.name,
							id: _this.user.user.userId
						}, // 扩展消息
						success: function() {
							let msgdata = {
								data: option.msg,
								ext: option.ext
							}
							_this.msgList.push(msgdata)
							_this.appendMsg(val)
						}, // 对成功的相关定义，sdk会将消息id登记到日志进行备份处理
						fail: function() {
							console.log('failed');
						} // 对失败的相关定义，sdk会将消息id登记到日志进行备份处理
					};
					msg.set(option);
					this.$imconn.send(msg.body);
					this.sendmsg = '';
				}
			},
			getHismsg() {
				this.$api.getMsg({
					name: this.id
				}, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						this.msgList = JSON.parse(res.data.c)
					} else {
						console.log('getMsg——failed');
					}
				});
			},
			appendMsg(data) {
				let cnt = {
					name: this.id,
					msg: {
						ext: {
							name: this.user.user.name
						},
						data: data
					}
				}
				this.$api.appendMsg(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {} else {
						console.log('appendMsg——failed');
					}
				});
			},
			init() {
				if (localStorage.getItem("user")) {
					this.user = JSON.parse(localStorage.getItem("user"))
					this.id = this.$route.query.id
					this.shareUrl = window.location.origin + window.location.pathname + "#/phoneLive?id=" + this.id
					this.joinLive();
					this.getUrl();
					this.getHismsg();
					this.dialogVisible = false
				} else {
					this.$message.error("请先登录")
				}
			}
		},
		mounted() {
			this.loginWebIM()
			this.init()
		}
	}
</script>

<style lang="scss">
	@import '@/assets/style/style.scss';

	#shareit {
		position: absolute;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.85);
		text-align: center;
		top: 0;
		left: 0;
		z-index: 105;
	}

	#shareit img {
		max-width: 100%;
	}

	.arrow {
		position: absolute;
		right: 10%;
		top: 5%;
	}

	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}

	.shareTextClass {
		font-size: 18px;
		font-weight: 500;
		color: #448aff;
		margin-bottom: 10px;
	}

	.input {
		width: 50%;
		height: 30px;
		border: 1px solid #afafaf;
		background-color: #f4f4f4;
		border-radius: 3px 0 0 3px;
	}

	.fasong {
		width: 70px;
		height: 34px;
		line-height: 34px;
		background-color: #1aabf9;
		color: #fff;
		text-align: center;
		border-radius: 0 3px 3px 0;
		font-size: 14px;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		margin: 10px 0;
	}

	.qh_title {
		color: #333;
		padding-bottom: 10px;

	}

	.blue {
		color: #3d9ee2;
		border-bottom: 2px solid #3d9ee2;
	}

	.content_box {
		width: 100%;
		height: 200px;
		background-color: #fff;
		border-radius: 8px;
		color: #333;
		font-size: 25px;
		font-weight: bold;
		text-align: center;
		line-height: 200px;
	}

	.prism-detect-info {
		display: none;
	}

	.prism-player .prism-ErrorMessage .prism-error-operation .prism-button-orange {
		display: none;
	}

	.chat-content {
		width: 100%;
		padding: 20px;

		.word {
			display: flex;
			margin-bottom: 20px;

			img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}

			.info {
				margin-left: 10px;

				.time {
					font-size: 12px;
					color: rgba(51, 51, 51, 0.8);
					margin: 0;
					height: 20px;
					line-height: 20px;
					margin-top: -5px;
				}

				.info-content {
					padding: 10px;
					font-size: 14px;
					background: #fff;
					position: relative;
					margin-top: 8px;
				}

				//小三角形
				.info-content::before {
					position: absolute;
					left: -8px;
					top: 8px;
					content: '';
					border-right: 10px solid #FFF;
					border-top: 8px solid transparent;
					border-bottom: 8px solid transparent;
				}
			}
		}

		.word-my {
			display: flex;
			justify-content: flex-end;
			margin-bottom: 20px;

			img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}

			.info {
				width: 90%;
				margin-left: 10px;
				text-align: right;

				.time {
					font-size: 12px;
					color: rgba(51, 51, 51, 0.8);
					margin: 0;
					height: 20px;
					line-height: 20px;
					margin-top: -5px;
					margin-right: 10px;
				}

				.info-content {
					max-width: 70%;
					padding: 10px;
					font-size: 14px;
					float: right;
					margin-right: 10px;
					position: relative;
					margin-top: 8px;
					background: #A3C3F6;
					text-align: left;
				}

				//小三角形
				.info-content::after {
					position: absolute;
					right: -8px;
					top: 8px;
					content: '';
					border-left: 10px solid #A3C3F6;
					border-top: 8px solid transparent;
					border-bottom: 8px solid transparent;
				}
			}
		}
	}
</style>
